import { createGlobalStyle } from 'styled-components';

const globalStyles = createGlobalStyle`
  * {
    margin: 0px;
    padding: 0px;
    box-sizing: border-box;
    outline: none;
    font-family: 'Tahoma', sans-serif;

    button {
      cursor: pointer;
    }
  }
`;

export default globalStyles;
